import axios from "axios"

export class ServicoFuncionario {
  constructor() {
    this.urlServico = process.env.VUE_APP_URL_VOLUPIA + `/api/Funcionario`
  }
  buscarFuncionario() {
    return axios({
      url: this.urlServico + `/GetAll`,
      method: "GET"
    })
  }
  salvarFuncionario(funcionario) {
    let config = {
      withCredentials: false,
      crossdomain: true
    }
    return axios.post(this.urlServico + "/Salvar", funcionario, config).catch(error => {
      alert("Erro ao salvar um novo funcionário " + error)
      return Promise.reject(error)
    })
  }
  buscarPorId(id) {
    return axios({
      url: this.urlServico + `/GetById?id=${id}`,
      method: "GET"
    })
  }
}
